const config = {
  api: {
    baseURL: import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000/api',
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000', 10),
  },
  app: {
    name: import.meta.env.VITE_APP_NAME || 'h.lab',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  },
  azure: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    tenantId: import.meta.env.VITE_AZURE_TENANT_ID || '',
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
  },
};

export default config;
